<template>
  <div class="mob-segmented-button">
    <button
      v-for="item in items"
      :key="item.key"
      :class="{
        selected: selectedKey === item.key,
        'not-selected': selectedKey !== item.key,
      }"
      @click="selectKey(item.key)"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "MobSegmentedButton",
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    selectedKey() {
      return this.value;
    },
  },
  methods: {
    selectKey(key) {
      this.$emit("input", key);
    },
  },
};
</script>

<style scoped>
.mob-segmented-button {
  @apply inline-flex rounded-md p-1 bg-neutral-100;
}

.mob-segmented-button button {
  @apply flex-1 px-4 py-2 text-center cursor-pointer transition-colors rounded-md;
}

.selected {
  @apply bg-white text-neutral-800 shadow-sm;
}

.not-selected {
  @apply bg-transparent text-neutral-600;
}

.not-selected:hover {
  @apply bg-gray-100;
}
</style>
